import React from 'react'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Field, Formik, Form } from 'formik'
import { TextField } from 'formik-material-ui'
import { object, string } from 'yup'
import * as Yup from 'yup'
import { registerTeacher } from '../../../actions/auth'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { PersonAdd } from '@mui/icons-material'

const TeacherRegisterForm = (props) => {
  const dispatch = useDispatch()

  const theme = useTheme()

  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  const history = useHistory()

  const auth = useSelector((state) => state.auth)
  const { loading } = auth

  const validation = object({
    name: string().required('Name is required'),
    email: string().email('Email is not correct').required('Email is required'),
    password: string()
      .min(6, 'Password must have at least 6 characters')
      .required('Password is required'),
    confirmPassword: string()
      .oneOf([Yup.ref('password'), null], 'Passwords are not matched')
      .required('Confirm password is required'),
  })

  const onSubmitHandler = async (values, { setSubmitting, resetForm }) => {
    dispatch(registerTeacher(values))
    resetForm({ name: '', email: '', password: '', confirmPassword: '' })
    setSubmitting(false)
    history.push('/teachers/login')
  }

  return (
    <Formik
      initialValues={{ name: '', email: '', password: '' }}
      validationSchema={validation}
      onSubmit={onSubmitHandler}
    >
      {({ isSubmitting, isValid }) => (
        <Form className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Card style={{ maxWidth: matchesLG ? '60%' : matchesMD ? '70%' : '80%' }}>
            <CardContent>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{ width: '100%' }}
              >
                <Grid item>
                  <PersonAdd fontSize='large' color='primary' />
                </Grid>

                <Grid item>
                  <Typography
                    variant="h5"
                    style={{
                      textTransform: 'uppercase',
                      textAlign: 'center',
                      fontWeight: 500
                    }}
                  >
                    Register teacher account
                  </Typography>
                </Grid>
                <Grid
                  item
                  style={{ width: '100%', marginBottom: '1em' }}
                >
                  <Field fullWidth name="name" component={TextField} label="Name" />
                </Grid>
                <Grid
                  item
                  style={{ width: '100%', marginBottom: '1em' }}
                >
                  <Field
                    fullWidth
                    name="email"
                    component={TextField}
                    label="Email"
                  />
                </Grid>
                <Grid
                  item
                  style={{ width: '100%', marginBottom: '1em' }}
                >
                  <Field
                    name="password"
                    component={TextField}
                    label="Password"
                    fullWidth
                    type="password"
                  />
                </Grid>
                <Grid
                  item
                  style={{ width: '100%', marginBottom: '1em' }}
                >
                  <Field
                    fullWidth
                    name="confirmPassword"
                    component={TextField}
                    label="Confirm password"
                    type="password"
                  />
                </Grid>
                <Grid
                  item
                  style={{ width: '100%' }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{ color: 'white' }}
                    fullWidth
                    disabled={!isValid || isSubmitting}
                  >
                    {loading ? <CircularProgress color="secondary" /> : 'Sign up'}
                  </Button>
                </Grid>
              </Grid>

              <Grid
                container
                alignItems="center"
                justifyContent="center"
                style={{ margin: '0.7em 0' }}
              >
                <Grid item>
                  <Typography variant="body1">Already registered?</Typography>
                </Grid>
                <Grid item>
                  <Button
                    component={Link}
                    to="/teachers/login"
                    variant="text"
                    style={{
                      fontSize: '1rem',
                      textTransform: 'none',
                      fontWeight: '600',
                    }}
                    disableRipple
                  >
                    Sign in
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Form>
      )}
    </Formik>
  );
}
export default TeacherRegisterForm
